import { observer } from 'mobx-react-lite';
import * as styles from './SearchTerm.css';

function SearchTerm({ searchTerm }: { searchTerm: string }) {
  return (
    <h1 className={styles.Term}>
      &quot;
      {searchTerm}
      &quot;
    </h1>
  );
}

export default observer(SearchTerm);
